import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { LeistungseinheitPipe } from './leistungseinheit.pipe';
import { EnergietraegerPipe } from './energietraeger.pipe';
import { PlanwertStatusPipe } from './planwert-status.pipe';
import { PlanwertTypePipe } from './planwert-type.pipe';

@NgModule({
    declarations: [
        LeistungseinheitPipe,
        EnergietraegerPipe,
        PlanwertStatusPipe,
        PlanwertTypePipe,
    ],
    exports: [
        LeistungseinheitPipe,
        EnergietraegerPipe,
        PlanwertStatusPipe,
        PlanwertTypePipe,
    ],
    providers: [
        DecimalPipe,
        LeistungseinheitPipe,
        EnergietraegerPipe,
        PlanwertStatusPipe,
        PlanwertTypePipe,
    ],
    imports: [
        CommonModule,
    ],
})
export class PipeModule {
}
